import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=b08c66b6&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=b08c66b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c66b6",
  null
  
)

export default component.exports